// extracted by mini-css-extract-plugin
module.exports = {"maxSmallMobile":"359px","maxMobile":"767px","maxTablet":"1279px","maxDesktop":"1439px","minSmallMobile":"360px","minMobile":"768px","minTablet":"1280px","minDesktop":"1440px"};